import { createContext, useState, useEffect, useCallback } from "react";
import authApi from "../api/authApi";

export const AuthContext = createContext();

export default function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  // Tải thông tin user (dùng trong login hoặc khi reload trang)
  const loadUser = useCallback(async () => {
    try {
      const me = await authApi.me();
      setUser(me.data);
    } catch {
      setUser(null);
    }
    setReady(true);
  }, []);

  // Khi FE load lại → kiểm tra có token thì gọi /me
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) loadUser();
    else setReady(true);
  }, [loadUser]);

  // Login
  async function login(email, password) {
    const res = await authApi.login(email, password);

    localStorage.setItem("accessToken", res.data.accessToken);
    localStorage.setItem("refreshToken", res.data.refreshToken);

    await loadUser();
  }

  // Logout
  function logout() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    setUser(null);
  }

  // FE biết user đã authenticated hay chưa
  const isAuthenticated = !!user;

  return (
    <AuthContext.Provider value={{ user, isAuthenticated, login, logout, ready }}>
      {children}
    </AuthContext.Provider>
  );
}
